import { Container, Link, PageHeading } from '~/components'
import { ContactMethods } from '~/features/common/contact-methods'

import { ContactForm } from '../components'

export const ContactPage = () => {
  return (
    <main>
      <div className="bg-grayBg md:p-[38px]">
        <Container className="flex max-w-[600px] flex-col gap-y-10 bg-white py-6 md:rounded-lg md:px-6">
          <PageHeading>お問い合わせ</PageHeading>

          <section aria-label="office-info-section">
            <div className="flex flex-col gap-y-10">
              <Link href="/faq">よくある質問はこちら</Link>
              <ContactMethods />
              <ContactForm />
            </div>
          </section>
        </Container>
      </div>
    </main>
  )
}
